export default "__VITE_ASSET___IRaNpeX__"